import { render, staticRenderFns } from "./WaitingListQRCode.vue?vue&type=template&id=b13e2760&scoped=true&"
import script from "./WaitingListQRCode.vue?vue&type=script&lang=js&"
export * from "./WaitingListQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13e2760",
  null
  
)

export default component.exports